import type { FaireProductEntity } from "../../entity_types/product";

export const p_7gr3wzygqk: FaireProductEntity = {
  token: "p_7gr3wzygqk",
  type: "product",
  name: "Lightweight Knit Wrap – Soft Triangle Neck Scarf_CWASC2704",
  brandToken: "b_3eopd3scey",
  brandName: "ACCITY",
  imageUrl:
    "https://cdn.faire.com/fastly/bb341abf839134ec9bbba1de8e986f3e771cf64fd2e3421ece167e2df670bd0e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9b18fe8278b3e2f8d22ad7915c810d514b32bac4a1f45a07459e1c7bc1895aa1.jpeg",
    "https://cdn.faire.com/fastly/a0c4d7de6652db663a2105e1b6b54cd41b918d1321f15c8cf7d6e0fd1e3dc337.png",
    "https://cdn.faire.com/fastly/d2bbd1bbe9ce01847d649b1826ca43e8398514b7fb1dec54fce694afab991d9f.png",
    "https://cdn.faire.com/fastly/3235d3dd387393745fae7271fecd68ada5f9d04dba6e9404669442f6c879dde5.png",
    "https://cdn.faire.com/fastly/fd05feaeceb7b4c6ed0466971cfb5ac3ccb5c15036dfa862756430eabe2aed3d.png",
    "https://cdn.faire.com/fastly/610a4a17238fa478104788714a3e36855eade03204344821170f1cf49c1bd1b0.png",
    "https://cdn.faire.com/fastly/7f01744f93713e0deec9e49e680c80ce07e810dd5eed6fd7425d3e3e80808f78.png",
    "https://cdn.faire.com/fastly/eeb3e39ad6244113d9510a569b74e77e185066adb78ea20043e5792d6e8ed19b.png",
    "https://cdn.faire.com/fastly/ef9046631ddbd410d2359ca104cf0c0f577c1b0c2eb9ccfaf9a9f4035acb0c01.png",
    "https://cdn.faire.com/fastly/00ae12ca2573fd01d652c1d54173b8785a16a28e9187547178c6ea97639ad7c4.png",
    "https://cdn.faire.com/fastly/3ede64cbf77a0303f6f64462da94393c70016353a3306c69f9d9d79c2fe89333.png",
    "https://cdn.faire.com/fastly/23836b74d0725e0d5a94ffc6aaa0d4d0ca2345e1f5aefb87098b927b277e9019.png",
    "https://cdn.faire.com/fastly/b632fc3d996f61bcf832292280ffca8f97e9a1d5acd85e84c6be546bed0e8599.png",
    "https://cdn.faire.com/fastly/db004018b91bc1de9838af3a3bf108087429a880410b89835a5d578e2431759a.png",
    "https://cdn.faire.com/fastly/9c375368ca02130fed6cbffe22695cefcb1298395c14bb3311fe291a96c0ca91.png",
    "https://cdn.faire.com/fastly/7e46627528b6dff47c71ae4c4e903586c3e4d9c024304e3b2a6c9f4847f00134.png",
    "https://cdn.faire.com/fastly/8ee47bbc33cd700e43352a7b096b9a4861b9bf48d5d612db469b86e1680c9c16.png",
    "https://cdn.faire.com/fastly/1ea08f2940c6bd118589cc0e9991a4467c2488503934a692a1fae39692be95e9.png",
  ],
  priceDollars: 33.5,
  description:
    "- Material: 100% cashmere\n- Size: see picture\n- Weight: 50g\n\nProduct types on the shelves this issue:\nCashmere scarf, cashmere triangle scarf, cashmere shawl, 100% cashmere scarf, oversized cashmere shawl, soft cashmere scarf, winter cashmere scarf, cashmere shawl, light cashmere shawl, cashmere travel shawl, luxury cashmere scarf, cashmere tassel scarf, cashmere plaid scarf, comfortable cashmere shawl, elegant cashmere shawl, ladies cashmere scarf, men's cashmere scarf, neutral tone cashmere scarf, classic knitted cashmere scarf, warm cashmere shawl, fashionable cashmere scarf, cashmere shawl, simple cashmere shawl, double-sided cashmere shawl, blanket cashmere scarf.",
  tags: [],
  msrpDollars: 67,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T17:55:50.327Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
